import { GrClose } from "react-icons/gr";
import { styled, applyClassName } from "@glitz/react";
import { spacing, white, green, darkGreen } from "../theme";

type CloseIconProps = {
  onClose: () => void;
};
const CloseIcon = ({ onClose }: CloseIconProps) => {
  return (
    <Wrapper>
      <ContentWrapper onClick={onClose}>
        <IconWrapper>
          <Icon />
        </IconWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: "flex",
  justifyContent: "flex-end",
});

const ContentWrapper = styled.div({
  position: "relative",
});

const Icon = styled(applyClassName(GrClose), {
  fontSize: "25px",
  color: white,
});

const IconWrapper = styled.div({
  cursor: "pointer",
  padding: { x: spacing.m, y: spacing.s },
  backgroundColor: green,
  ":hover": {
    backgroundColor: darkGreen,
  },
});

export default CloseIcon;
